import React from 'react';

import CarIcon from '../../icons/services/car.svg';

import DoorLockout from '../../icons/services/home/doorLockout.svg';
import DoorRepair from '../../icons/services/home/doorRepair.svg';
import LockChange from '../../icons/services/home/lockChange.svg';
import FreshLock from '../../icons/services/home/freshLock.svg';
import ReKey from '../../icons/services/home/reKey.svg';

import AutoLockout from '../../icons/services/auto/autoLockout.svg';
import AutoNewKey from '../../icons/services/auto/autoNewKey.svg';
import AutoIgnition from '../../icons/services/auto/autoIgnition.svg';

import BasicSafe from '../../icons/services/safe/basicSafe.svg';
import HighEndSafe from '../../icons/services/safe/highEndSafe.svg';

import CommercialLowVoltage from '../../icons/services/commercial/commercialLowVoltage.svg';
import CommercialPanicBar from '../../icons/services/commercial/commercialPanicBar.svg';
import CommercialBuzzer from '../../icons/services/commercial/commercialBuzzer.svg';
import CommercialEmergencyExit from '../../icons/services/commercial/commercialEmergencyExit.svg';

import GarageCable from '../../icons/services/garage/cable.svg';
import GarageSpring from '../../icons/services/garage/spring.svg';
import GarageDoor from '../../icons/services/garage/garageDoor.svg';
import GarageRemote from '../../icons/services/garage/remote.svg';

import CarpetCleaning from '../../icons/services/carpet/cleaning.svg';
import CarpetDeepCleaning from '../../icons/services/carpet/deepCleaning.svg';
import CarpetOdorRemoval from '../../icons/services/carpet/odorRemoval.svg';
import CarpetStains from '../../icons/services/carpet/carpetStains.svg';
import { SERVICE } from '../../utils/constants';

const icons = {
  [SERVICE.HOME.DOOR_LOCKOUT]: <DoorLockout />,
  [SERVICE.HOME.RE_KEY]: <ReKey />,
  [SERVICE.HOME.LOCK_CHANGE]: <LockChange />,
  [SERVICE.HOME.DOOR_REPAIR]: <DoorRepair />,
  [SERVICE.HOME.FRESH_LOCK]: <FreshLock />,

  [SERVICE.COMMERCIAL.LOW_VOLTAGE]: <CommercialLowVoltage />,
  [SERVICE.COMMERCIAL.PANIC_BAR]: <CommercialPanicBar />,
  [SERVICE.COMMERCIAL.BUZZER]: <CommercialBuzzer />,
  [SERVICE.COMMERCIAL.EMERGENCY_EXIT]: <CommercialEmergencyExit />,

  [SERVICE.AUTO.LOCKOUT]: <AutoLockout />,
  [SERVICE.AUTO.NEW_KEY]: <AutoNewKey />,
  [SERVICE.AUTO.IGNITION]: <AutoIgnition />,

  [SERVICE.SAFE.BASIC_SAFE]: <BasicSafe />,
  [SERVICE.SAFE.HIGH_END_SAFE]: <HighEndSafe />,

  [SERVICE.GARAGE.CABLE_REPAIR]: <GarageCable />,
  [SERVICE.GARAGE.SPRING_REPAIR]: <GarageSpring />,
  [SERVICE.GARAGE.DOOR_INSTALLATION]: <GarageDoor />,
  [SERVICE.GARAGE.OPENER]: <GarageRemote />,

  [SERVICE.CARPET.CLEANING]: <CarpetCleaning />,
  [SERVICE.CARPET.DEEP_CLEANING]: <CarpetDeepCleaning />,
  [SERVICE.CARPET.ODOR_REMOVAL]: <CarpetOdorRemoval />,
  [SERVICE.CARPET.STAINS_REMOVAL]: <CarpetStains />,
};

export const getIcon = (id) => icons[id] || <CarIcon />;
